import React, { useState, useEffect } from "react";
import { NameCard } from "./NameCard";
import {
  getEffortAssumptions,
  createEffortAssumptions,
  updateEffortAssumptions,
  deleteEffortAssumptions,
} from "../../../apis/Business/AssumptionsApi";
import "./index.css";
import plusIcon from "../../../assets/shapes_svg/ambition/plus-icon.svg";
import { useUserAccess } from "../../../components/WriteAccessContext";

const Assumptions = ({ effortId }) => {
  const [assumptions, setAssumptions] = useState([]);
  const [newAssumption, setNewAssumption] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");
  const { userAccess } = useUserAccess();

  useEffect(() => {
    const fetchAssumptions = async () => {
      try {
        const fetchedAssumptions = await getEffortAssumptions(effortId);
        setAssumptions(fetchedAssumptions);
      } catch (error) {
        console.error("Failed to fetch assumptions", error);
      }
    };

    if (effortId) {
      fetchAssumptions();
    }
  }, [effortId]);

  const addAssumption = async () => {
    if (newAssumption.trim()) {
      try {
        const createdAssumption = await createEffortAssumptions(effortId, {
          assumptions: newAssumption,
        });

        setAssumptions([
          ...assumptions,
          {
            id: createdAssumption.id,
            assumptions: newAssumption,
          },
        ]);
        setNewAssumption("");
      } catch (error) {
        console.error("Failed to create assumption", error);
      }
    }
  };

  const updateAssumption = async (id, newDescription) => {
    try {
      await updateEffortAssumptions(effortId, id, {
        assumptions: newDescription,
      });

      setAssumptions(
        assumptions.map((assumption) =>
          assumption.id === id
            ? { ...assumption, assumptions: newDescription }
            : assumption
        )
      );
      setEditingId(null);
    } catch (error) {
      console.error("Failed to update assumption", error);
    }
  };

  const deleteAssumption = async (id) => {
    try {
      await deleteEffortAssumptions(effortId, id);

      setAssumptions(assumptions.filter((assumption) => assumption.id !== id));
    } catch (error) {
      console.error("Failed to delete assumption", error);
    }
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter") {
      updateAssumption(id, editingText);
    }
  };

  return (
    <div
      style={{
        padding: "20px 20px 20px 0",
        display: "flex",
        gap: "20px",
      }}
    >
      <NameCard
        deptName={"Assumptions"}
        isBottom={false}
        className={"other-effort-container"}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
        className="action-plans-parent-bubble"
      >
        <input
          type="text"
          placeholder="Type assumption here"
          value={newAssumption}
          onChange={(e) => setNewAssumption(e.target.value)}
          style={{
            padding: "12px",
            borderRadius: "4px",
            border: "none",
            fontSize: "14px",
          }}
          className="assumptions-input-bg"
          disabled={userAccess !== "write"}
        />
        <button
          onClick={addAssumption}
          disabled={userAccess !== "write"}
          style={{
            padding: "12px",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            gap: "8px",
            fontSize: "14px",
          }}
          className="assumptions-input-bg"
        >
          <img src={plusIcon} alt="Plus Icon" width={20} height={20} />
          <h5 style={{ color: "#1B3764", fontSize: "14px" }}>
            {" "}
            Add Assumption
          </h5>
        </button>
        {assumptions.map((assumption) => (
          <div
            key={assumption.id}
            style={{
              padding: "12px",
              backgroundColor: "#e0e8e8",
              borderRadius: "4px",
              fontSize: "14px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {editingId === assumption.id ? (
              <input
                type="text"
                disabled={userAccess !== "write"}
                value={editingText}
                onChange={(e) => setEditingText(e.target.value)}
                onBlur={() => updateAssumption(assumption.id, editingText)}
                onKeyDown={(e) => handleKeyDown(e, assumption.id)}
                autoFocus
                style={{
                  width: "100%",
                  padding: "4px",
                  border: "none",
                  backgroundColor: "transparent",
                  fontSize: "14px",
                }}
                className="assumptions-input-bg"
              />
            ) : (
              <span
                onClick={() => {
                  setEditingId(assumption.id);
                  setEditingText(assumption.assumptions);
                }}
              >
                {assumption.assumptions}
              </span>
            )}
            {/* <div>
              <button onClick={() => deleteAssumption(assumption.id)}>
                Delete
              </button>
            </div> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Assumptions;
